/**
 * @typedef {import('./BlogSearchFormProps').default} Props
 */

import BlogFilterSearch from './BlogFilterSearch';
import React from 'react';

/**
 * Backward-compatible wrapper around the reusable BlogFilterSearch UI.
 * @param {Props} props
 * @returns {JSX.Element}
 */
export default function BlogSearchForm(props) {
	return (
		<BlogFilterSearch
			categoryFilterList={props.categoryFilterList}
			className={props.className}
			disabled={props.disabled}
			onSubmit={props.onSubmit}
			searchQuery={props.searchQuery}
			selectedCategoryId={props.selectedCategoryId}
			selectedTagId={props.selectedTagId}
			tagFilterList={props.tagFilterList}
		/>
	);
}
